<template>
	<div class="ht-profile-user-pay-type">
		<div v-if="$route.params.type == 'success'" class="pay-success">
			<h1 class="title pay-success">{{ $t('Transaction successful') }}</h1>
		</div>
		<div v-if="$route.params.type == 'failed'" class="pay-failed">
			<h1 class="title pay-failed">{{ $t('Transaction failed') }}</h1>
		</div>
		<div v-if="$route.params.type == 'cancel'" class="pay-failed">
			<h1 class="title pay-failed">{{ $t('Transaction aborted') }}</h1>
		</div>		
		<br>
		<b-button @click="$router.push('/profile/mybids')" type="is-info">{{ $t('back') }}</b-button>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			loading: true,
		}
	},
	props: {},
	mounted() {
		console.log('ROUTER', this.$route.params.type)
	},
	methods: {},
	watch: {},
}
</script>
<style lang="css">
.ht-profile-user-pay-type {
	height: 50vh;
	padding-top: 40px;
	text-align: center;
}
.pay-success {
	color: green;
}
.pay-failed {
	color: red;
}
</style>
